import React from "react";
import { connect } from "react-redux";
import { EntryPoint } from "@plans/tiles";
import * as modalAction from "./../../action/modalWindow";

function EmberEntryPoint(props) {
  const {
    dispatch,
  } = props;

  const entry = () => {
    return {
      backgroundColor: 'red',
      title: {
        children: <div style={{ minHeight: '678px' }}>
          <h3 style={{ color: 'yellow', position: 'absolute', top: 10, left: 15 }}>Already a Verizon mobile customer?</h3>
          <p style={{ fontSize: '24px', position: 'absolute', top: 150, left: 15, color: 'white' }}>Sign in to save $15/mo <br/> on Fios Home Internet.<br/> 1 Gig or 2 Gig <br/> customers also get <br/> $10/mo credit on any <br/> eligible perk. </p>
          <button style={{ borderRadius: '50px', position: 'absolute', textAlign: 'center', padding: '10px 18px', fontSize: '18px', backgroundColor: 'white', top: 425 }}>Sign In</button>
        </div>,
      },
      onClick: (e) => { modalAction.openModalWindow("mnhSignIn", dispatch) },
    }
  }

  return (
    <EntryPoint {...entry()} />
  );
}

export default connect()(EmberEntryPoint);
